module.exports = __webpack_public_path__ + "static/media/platform_logo.eda4b296.png";